<script setup lang="ts">
  import { Modal, FormInput, UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    label: string
    items: string[]
  }>()

  const showModel = defineModel<boolean>('show', { default: false })
  const searchModel = defineModel<string>('search', { default: '' })

  defineEmits<{
    search: []
    select: [item: string]
  }>()
</script>

<template>
  <Modal v-model:show="showModel">
    <template #header>
      {{ label }}
    </template>
    <FormInput label="Email" v-model="searchModel" @input="$emit('search')" />

    <div v-if="items && items.length > 0" class="button-list">
      <div v-for="item in items" :key="item">
        <UiButton @click="$emit('select', item)" :label="item" class="button" />
      </div>
    </div>
    <div v-else>Geen resultaten</div>
  </Modal>
</template>

<style scoped lang="css">
  .button {
    width: 100%;
  }

  .button-list {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }
</style>
